import { render, staticRenderFns } from "./detail-card.vue?vue&type=template&id=051dfa10&scoped=true&"
import script from "./detail-card.vue?vue&type=script&lang=js&"
export * from "./detail-card.vue?vue&type=script&lang=js&"
import style0 from "./detail-card.vue?vue&type=style&index=0&id=051dfa10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dfa10",
  null
  
)

export default component.exports